module.exports = __webpack_public_path__ + "img/03-ข้อมูลทั่วไป.e2ceffe5.png";